export const lifeTranslation = {
	translation: {
		exposure: {
			singular: {
				upper: 'Coverage',
				lower: 'coverage',
			},
			plural: {
				upper: '$t(exposure.singular.upper)s',
				lower: '$t(exposure.singular.lower)s',
			},
		},
		peril: {
			singular: {
				upper: 'Rider/Benefit',
				lower: 'rider/benefit',
			},
			plural: {
				upper: 'Riders/Benefits',
				lower: 'riders/benefits',
			},
		},
		endorsement: {
			singular: {
				upper: 'Policy Change',
				lower: 'policy change',
			},
			plural: {
				upper: '$t(endorsement.singular.upper)s',
				lower: '$t(endorsement.singular.lower)s',
			},
		},
	},
};
